<h2 mat-dialog-title>
  <mat-icon>warning</mat-icon>
  Error message
</h2>
<mat-dialog-content>
  @if (message) {
    <p> {{message}} </p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" mat-dialog-close> Confirm </button>
</mat-dialog-actions>